// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalAssessmentStudentDetail_modal__WEzRY"};